import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, } from "../../components"
import { Button, Radio, RadioGroup, Select, SelectItem, Input, addToast, Card, CardBody, Divider, Modal, NumberInput } from "@heroui/react"
import { apiRoute, ENUM_BILL_TYPE, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_TRADE_TYPE, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, funValidateNoInput, getModMandatory, getModValue, getModVisiblity, linksUrl, URIEncrypt, } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { useDispatch, useSelector } from "react-redux"
import { faCancel, faMagnifyingGlass, faClose, faDownload, faDownLong, faFile, faFileEdit, faFilter, faGem, faPenToSquare, faPlus, faSave, faSquareXmark, faTrashCan, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import { DataGrid } from "@mui/x-data-grid"
import { Box, FormControl, Chip, Checkbox, Autocomplete, ListItemText, MenuItem, OutlinedInput, TextField, Typography } from "@mui/material"
import { join } from "lodash"
import { funCheckNumber } from "../../Utility/utility"
const isNumericColumn = (values) => {
    return values.every(v => !isNaN(parseFloat(v)) && isFinite(v));
};
const SortIconNone = () => <span className="text-blue-300" style={{ fontSize: "12px" }}>⇅</span>;
const SortIconAsc = () => <span className="text-blue-400" style={{ fontSize: "12px" }}>▲</span>;
const SortIconDesc = () => <span className="text-blue-400" style={{ fontSize: "12px" }}>▼</span>;
const SinglePktPriceUpdate = () => {
    const { compCode, isMultipleCompany } = useSelector((state) => state.company)
    const [CurrencySetting, setCurrencySetting] = useState("")
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth)
    const { data: masterData = [] } = useFetchWithBody({
        url: apiRoute.stockEntry.paramMasterData,
        queryKey: "StockItemMaster",
    })
    const { isError, isPending, mutate: funUpdate } = usePost({
        url: apiRoute.stockEntry.updatePrice,
        queryKey: "funAddUpdateStockRate",
        onSuccessTasks: (data) => {
            toast.success("Rate Updated...", {
                position: "top-center",
            }
            )
        }
    })
    const { data = [], isError: isErrorFetch, isPending: isPendingData, mutate: filterData } = usePost({
        url: apiRoute.stockEntry.fetchPriceupData,
        queryKey: "rateUpdatestck",
        onSuccessTasks: (data) => {
            //setRows(data)


        }
    })
    const { isError: isErrorModSet, data: modSetting = [], mutate: filterModSetting } = usePost({
        url: apiRoute.modSetting.getMultiModSetting,
        queryKey: "fetchModSettingStockItem",
    })

    const [selStockType, setSelStockType] = useState("P")
    const [selFromSize, setSelFromSize] = useState("")
    const [selToSize, setSelToSize] = useState("")
    const [selShape, setSelShape] = useState(new Set([]))
    const [selColor, setSelColor] = useState(new Set([]))
    const [selFancyColor, setSelFancyColor] = useState(new Set([]))
    const [selPurity, setSelPurity] = useState(new Set([]))
    const [selLab, setSelLab] = useState("")
    const [selConRate, setSelConRate] = useState("")
    const [fixRate, setfixRate] = useState("")
    const [fixRateDollar, setfixRateDollar] = useState("")
    const [selDollarRate, setSelDollaRate] = useState(null)
    const [selRsRate, setSelRsRate] = useState(null)
    const [selectFilter, setSelectFilter] = useState({});
    const [sortConfig, setSortConfig] = useState({ field: null, order: null });

    const [rows, setRows] = useState([])
    const formField = {
        shapeCode: "shapeCode",
        colorCode: "colorCode",
        purityCode: "purityCode",
        fancyColor: "fancyColor",
        stockType: "stockType",
        fromSize: "fromSize",
        toSize: "toSize",
        lab: "lab",
        dRate: "dRate",
        rate: "rate"
    }

    const RowsField = {
        detailId: "DetailId",
        itemCode: "itemCode",
        itemName: "itemName",
        itemDetail: "itemDetail",
        lotNo: "L_Code",
        pktNo: "PktNo",
        shapeCode: "S_Code",
        shapeName: "ShapeName",
        colorCode: "Sh_Code",
        colorName: "ColorName",
        purityCode: "Q_Code",
        purityName: "PurityName",
        sizeCode: "Sz_Code",
        sizeName: "SizeName",
        lwRatio: "Lw_Code",
        pcs: "Pcs",
        weight: "Weight",
        rate: "Rate",
        dRate: "S_Rate",
        convRate: "C_Rate",
        dAmount: "AmountD",
        amount: "Amount",
        cut: "Cut",
        dia: "dia",
        lab: "Lab",
        bPcs: "BPcs",
        bWeight: "BWeight",
        reportNo: "ReportNo",
        rapRate: "rapRate",
        lessPer: "lessPer",
        stnLength: "stnLenth",
        tblDepth: "tblDepth",
        flrn: "flrn",
        crwnAngle: "crwnAngle",
        certiDate: "certiDate",
        certiNo: "certiNo",
        stoneId: "stoneId",
        srcRate: "Src_Rate",
        srcRateD: "Src_SRate",
        remarks: "Remarks",

    }
    useEffect(() => {
        if (modSetting && Object.keys(modSetting).length > 0) {
            const modData = modSetting.pageData
            const generalData = modSetting.masterData
            setCurrencySetting(getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, generalData) ?? ENUM_CURRENCY_SETTING_VAL.RS)

        }

    }, [modSetting])
    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard)

        filterModSetting({
            data: {
                page_mod: ENUM_MOD_NAME.StockPolishSingle,
                master_mod: ENUM_MOD_NAME.GeneralSettings
            }
        })


    }, [])
    const funCalAllAmount = (
        rowData,
        index,
        pcs,
        weight,
        currentID,
        vrate,
        fixRate,
        fixRateDollar,
        isfixUpdate
    ) => {

        const newRows = (Array.isArray(rowData) && rowData.length > 0)
            ? rowData
            : rows;

        const row = newRows[index] || {};

        // Safe numeric parser
        const num = (v) => parseFloat(v) || 0;

        let rate = num(row[RowsField.rate]);
        let dRate = num(row[RowsField.dRate]);
        const convRate = num(vrate);

        const tPcs = pcs > 0 ? pcs : num(row[RowsField.pcs]);
        const tWeight = weight > 0 ? weight : num(row[RowsField.bWeight]);

        const isRS = CurrencySetting === ENUM_CURRENCY_SETTING_VAL.RS;

        if (!isRS) {

            if (isfixUpdate) {
                // Prefer fixed rates, fallback to row
                const srcRate = num(row[RowsField.srcRate]);
                const srcRateD = num(row[RowsField.srcRateD]);

                rate = num(fixRate) || srcRate;
                dRate = num(fixRateDollar) || srcRateD;

                if (dRate && convRate > 0) {
                    rate = Math.round(funCheckNumber(dRate * convRate));
                }

                if (rate && convRate > 0) {
                    dRate = funCheckNumber(rate / convRate).toFixed(2);
                }

            } else {
                const isDollarEdit = currentID === RowsField.dRate || currentID === RowsField.convRate;
                const isRateEdit = currentID === RowsField.rate || currentID === RowsField.convRate;

                if (isDollarEdit) {
                    if (selConRate > 0)
                        rate = Math.round(funCheckNumber(dRate * convRate));
                } else if (isRateEdit) {
                    if (selConRate > 0)
                        dRate = funCheckNumber(rate / convRate).toFixed(2);
                }
            }
        }

        const amount = funCheckNumber(rate * tWeight).toFixed(2);
        const dAmount = funCheckNumber(dRate * tWeight).toFixed(2);

        return { amount, dAmount, dRate, rate, convRate };
    };

    // const funCalAllAmount = (rowData, index, pcs, weight, currentID, vrate, fixRate, fixRateDollar, isfixUpdate) => {
    //     const newRows = Array.isArray(rowData) && rowData.length > 0 ? [...rowData] : [...rows];
    //     const row = newRows[index] ?? {};

    //     // Fallback-safe numeric parsing
    //     const getNum = (val) => parseFloat(val) || 0;

    //     let rate = getNum(row[RowsField.rate]);
    //     let dRate = getNum(row[RowsField.dRate]);
    //     //const convRate = getNum(row[RowsField.convRate]);
    //     const convRate = getNum(vrate);
    //     const tPcs = pcs > 0 ? pcs : getNum(row[RowsField.pcs]);
    //     const tWeight = weight > 0 ? weight : getNum(row[RowsField.bWeight]);

    //     // Rate conversion based on currency and edited field
    //     if (CurrencySetting !== ENUM_CURRENCY_SETTING_VAL.RS) {
    //         if (isfixUpdate) {
    //             rate = getNum(fixRate) > 0 ? fixRate : getNum(row[RowsField.srcRate]);
    //             dRate = getNum(fixRateDollar) > 0 ? fixRateDollar : getNum(row[RowsField.srcRateD]);
    //             // console.log(rate,fixRate,fixRateDollar)
    //             rate = dRate && convRate > 0 ? Math.round(funCheckNumber(dRate * convRate)) : rate
    //             dRate = rate > 0 && convRate > 0 ? funCheckNumber(rate / convRate).toFixed(2) : dRate;
    //         }
    //         else {
    //             if ([RowsField.dRate, RowsField.convRate].includes(currentID)) {
    //                 rate = Math.round(funCheckNumber(dRate * convRate))
    //             } else if ([RowsField.rate, RowsField.convRate].includes(currentID)) {
    //                 dRate = funCheckNumber(rate / convRate).toFixed(2);
    //             }
    //         }
    //     }


    //     const amount = funCheckNumber(rate * tWeight).toFixed(2);
    //     const dAmount = funCheckNumber(dRate * tWeight).toFixed(2);

    //     return {
    //         amount,
    //         dAmount,
    //         dRate,
    //         rate,
    //         convRate
    //     };

    // }
    const handleSetValue = () => {
        // if (fixRateDollar > 0 && !selConRate > 0) {
        //     toast.error("enter Conv Rate", {
        //         position: 'top-center'
        //     })
        //     return;
        // }
        const newData = rows.map((ele, index) => {
            const calData = funCalAllAmount(ele, index, 0, 0, "", selConRate, fixRate, fixRateDollar, 1)
            //console.log(calData)
            return {
                ...ele, [RowsField.amount]: calData.amount, [RowsField.dAmount]: calData.dAmount, [RowsField.convRate]: calData.convRate
                , [RowsField.rate]: calData.rate, [RowsField.dRate]: calData.dRate
            }
        })
        // console.log(newData)
        setRows(newData)


    }
    const handleRestSetValue = () => {
        setSelConRate("")
        setfixRate("")
        setfixRateDollar("")
        const newData = rows.map((ele, index) => {
            // const calData = funCalAllAmount(ele, index, 0, 0, "", selConRate, fixRate, fixRateDollar,1)
            const drate = (ele[RowsField.srcRateD] * ele[RowsField.weight]).toFixed(2)
            const rate = (ele[RowsField.srcRate] * ele[RowsField.weight]).toFixed(2)
            return {
                ...ele, [RowsField.amount]: rate, [RowsField.dAmount]: drate, [RowsField.convRate]: 0
                , [RowsField.rate]: ele[RowsField.srcRate], [RowsField.dRate]: ele[RowsField.srcRateD]
            }
        })
        // console.log(newData)
        setRows(newData)


    }

    const handleChange = (e, rowId) => {
        const { name, value } = e.target
        // setIsMixStockGet(false)

        const isValid = funValidateNoInput(value);
        if (name == RowsField.remarks) {
            let index = rows.findIndex(ele => ele.id == rowId)
            const newRows = [...rows]
            // setSelectedGridRowId(index)

            newRows[index][name] = value
            setRows(newRows)
        }
        else {
            if (isValid) {
                let index = rows.findIndex(ele => ele.id == rowId)
                const newRows = [...rows]
                // setSelectedGridRowId(index)

                newRows[index][name] = value

                const CalColumn = [RowsField.rate, RowsField.dRate]
                if (CalColumn.includes(name)) {

                    const calData = funCalAllAmount(newRows, index, 0, 0, name, selConRate)

                    newRows[index][RowsField.amount] = calData.amount
                    newRows[index][RowsField.dAmount] = calData.dAmount

                    // console.log(calData)
                    if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
                        if (name != RowsField.dRate)
                            newRows[index][RowsField.dRate] = calData.dRate //.toFixed(2)
                        if (name != RowsField.rate)
                            newRows[index][RowsField.rate] = calData.rate //.toFixed(2)
                    }
                }
                setRows(newRows)
            }
        }
        // if (name == RowsField.convRate) {
        //     setConRate(value)
        //     const newData = rows.map((ele, index) => {
        //         const calData = funCalAllAmount(ele, index, 0, 0, name, value, fixRate, fixRateDollar)
        //         return {
        //             ...ele, [RowsField.amount]: calData.amount, [RowsField.dAmount]: calData.dAmount, [RowsField.convRate]: value
        //             , [RowsField.rate]: calData.rate, [RowsField.dRate]: calData.dRate
        //         }
        //     })
        //     // console.log(newData)
        //     setRows(newData)
        // }
        // else if (name == "fixRate") {
        //     setfixRate(value)
        //     const newData = rows.map((ele, index) => {
        //         const calData = funCalAllAmount(ele, index, 0, 0, name, selConRate, value, fixRateDollar)
        //         return {
        //             ...ele, [RowsField.amount]: calData.amount, [RowsField.dAmount]: calData.dAmount, [RowsField.convRate]: selConRate
        //             , [RowsField.rate]: value > 0 ? value : calData.rate, [RowsField.dRate]: calData.dRate
        //         }
        //     })
        //     // console.log(newData)
        //     setRows(newData)
        // }
        // else if (name == "fixRateDollar") {
        //     setfixRateDollar(value)
        //     const newData = rows.map((ele, index) => {
        //         const calData = funCalAllAmount(ele, index, 0, 0, name, selConRate, fixRate, value)
        //         return {
        //             ...ele, [RowsField.amount]: calData.amount, [RowsField.dAmount]: calData.dAmount, [RowsField.convRate]: selConRate
        //             , [RowsField.rate]: calData.rate, [RowsField.dRate]: value
        //         }
        //     })
        //     // console.log(newData)
        //     setRows(newData)
        // }
        // else {


        // }


    }

    const [initialColumn, setInitialColumn] = useState([
        RowsField.lotNo,
        RowsField.pktNo,
        RowsField.shapeName,
        RowsField.colorName,
        RowsField.purityName,
        RowsField.lab,
        RowsField.remarks,
        RowsField.bWeight,
        RowsField.dRate,
        RowsField.rate,
        RowsField.amount,
        RowsField.dAmount,
        RowsField.lwRatio
    ])
    const finalRows = useMemo(() => {
        let filtered = data.filter(item => {
            return Object.keys(selectFilter).every(field => {
                const selected = selectFilter[field];
                if (!selected?.length) return true;
                return selected.includes([RowsField.bWeight, RowsField.rate, RowsField.dRate, RowsField.amount
                    , RowsField.dAmount].includes(field) ? item[field] : String(item[field]));
            })

        });


        if (sortConfig.field && sortConfig.order) {
            const field = sortConfig.field;
            const values = filtered.map(r => r[field]);
            const isNum = isNumericColumn(values);

            filtered = [...filtered].sort((a, b) => {
                const av = a[field];
                const bv = b[field];
                if (isNum) return sortConfig.order === "asc" ? av - bv : bv - av;
                return sortConfig.order === "asc"
                    ? String(av).localeCompare(String(bv))
                    : String(bv).localeCompare(String(av));
            });
        }
        // setRows(filtered)
        return filtered;
    }, [data, selectFilter, sortConfig]);
    useEffect(() => {
        if (compCode.length > 0)
            setRows(finalRows)
    }, [finalRows])
    const itemGridHeadClass = "bill-grid-style"
    const filteredUniqueValuesMap = useMemo(() => {
        const map = {};
        initialColumn?.forEach(col => {
            const field = col;
            const values = [...new Set(data.map(d => d[field]))];
            map[field] = values;
        });
        return map;
    }, [data, initialColumn]);
    const handleRemoveTag = (field, value) => {
        const updated = selectFilter[field].filter((v) => v !== value);

        handleSelectChange(field, updated);
        // ⬆️ same function Autocomplete uses to update states
    };
    const handleSelectChange = (field, values) => {
        setSelectFilter(prev => ({ ...prev, [field]: values }));
    };
    /* ---------- 3-STATE SORTING ---------- */
    const handleSort = (field) => {
        return () => {
            setSortConfig(prev => {
                if (prev.field !== field) return { field, order: "asc" };
                if (prev.order === "asc") return { field, order: "desc" };
                if (prev.order === "desc") return { field: null, order: null };
            });
        };
    };
    const renderHeadFilter = (name, headername) => {
        const field = name

        const sortIcon =
            sortConfig.field !== field ? <SortIconNone /> :
                sortConfig.order === "asc" ? <SortIconAsc /> :
                    sortConfig.order === "desc" ? <SortIconDesc /> :
                        <SortIconNone />;
        return (
            <Box sx={{ display: "flex", flexDirection: "column", padding: "2px" }}>

                {/* Title + Sort Button */}
                <Box className={` flex items-center justify-between `}
                    // sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    onClick={handleSort(field)}
                    style={{ cursor: "pointer" }}
                >
                    <div style={{ fontSize: "0.655rem" }} className=" w-full text-center flex   justify-center items-center leading-snug whitespace-normal h-7 overflow-hidden" >
                        {headername}
                    </div>
                    {sortIcon}
                </Box>

                <Autocomplete
                    multiple
                    size="small"
                    options={(filteredUniqueValuesMap[field] || []).filter(opt => opt != null)} // always fallback to empty array
                    value={selectFilter[field] || []}
                    onChange={(e, newValue) => handleSelectChange(field, newValue)}
                    disabled={!filteredUniqueValuesMap[field] || filteredUniqueValuesMap[field].length === 0}
                    noOptionsText="No options available"
                    renderTags={() => null}
                    slotProps={{
                        chip: {
                            size: "small",
                            sx: { height: 20, fontSize: "10px", padding: "0 4px", "& .MuiChip-label": { padding: 0 } }
                        },
                        input: { sx: { padding: "2px 0px !important", fontSize: "11px" } },
                        popper: { sx: { fontSize: "12px" } },
                        listbox: {
                            sx: {
                                fontSize: "11px",
                                "& .MuiAutocomplete-option": { padding: "2px 8px", minHeight: "28px" }
                            }
                        }
                    }}
                    sx={{
                        "& .MuiAutocomplete-inputRoot": { padding: "0px 4px !important", minHeight: "30px", background: "#FFFFFF" },
                        "& .MuiOutlinedInput-root": { padding: "0px !important", height: "30px" }
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Search & Select"
                            variant="outlined"
                            size="small"
                            inputProps={{
                                ...params.inputProps, // ⚡ make sure inputProps exist
                                autoComplete: "off"
                            }}
                            sx={{
                                width: field == RowsField.shapeName ? "130px" : "95px",
                                "& .MuiInputLabel-root": { fontSize: "11px", }
                            }}
                        />
                    )}
                />




            </Box>
        )

    }
    //console.log(rows)
    const columns = [
        {
            field: RowsField.lotNo,
            headerName: "Lot No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderHeader: () => (
                <>
                    {renderHeadFilter(RowsField.lotNo, "Lot No")}
                </>
            ),
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.lotNo]}
                </div>)
        },
        {
            field: RowsField.pktNo,
            headerName: "Pkt No",
            minWidth: 110,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderHeader: () => (
                <>
                    {renderHeadFilter(RowsField.pktNo, "Pkt No")}
                </>
            ),
            renderCell: ({ row }) =>
            (
                <div>
                    {
                        row[RowsField.pktNo]
                    }
                </div>)
        },
        {
            field: RowsField.shapeName,
            headerName: "Shape",
            minWidth: 140,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderHeader: () => (
                <>
                    {renderHeadFilter(RowsField.shapeName, "Shape")}
                </>
            ),
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.shapeName]
                    }
                </div>)
        },
        {
            field: RowsField.colorCode,
            headerName: "Color",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderHeader: () => (
                <>
                    {renderHeadFilter(RowsField.colorName, "Color")}
                </>
            ),
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.colorName] //funGetName(RowsField.colorCode, row.colorCode)
                    }
                </div>)
        },
        {
            field: RowsField.purityName,
            headerName: "Purity",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderHeader: () => (
                <>
                    {renderHeadFilter(RowsField.purityName, "Purity")}
                </>
            ),
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.purityName]
                    }
                </div>)
        },

        // {
        //     field: RowsField.sizeName,
        //     headerName: "Size",
        //     minWidth: 110,
        //     flex: 1,
        //     headerAlign: "center",
        //     headerClassName: itemGridHeadClass,
        //     align: "center",
        //     renderHeader: () => (
        //         <>
        //             {renderHeadFilter(RowsField.sizeName, "Size")}
        //         </>
        //     ),
        //     renderCell: ({ row }) =>
        //     (
        //         <div>
        //             {row[RowsField.sizeName]
        //             }
        //         </div>)
        // },
        {
            field: RowsField.remarks,
            headerName: "Gradding",
            minWidth: 110,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderHeader: () => (
                <>
                    {renderHeadFilter(RowsField.remarks, "Gradding")}
                </>
            ),
            renderCell: ({ row }) =>
            (
                <div>
                    {
                        <input size="sm" variant="flat" type="text" name={RowsField.remarks}
                            className="bg-blue-50 w-24 rounded-md text-blue-600 h-7  border-1 border-blue-200 p-1  text-xs"
                            onChange={(e) => handleChange(e, row.id)} value={row[RowsField.remarks]} />

                    }
                </div>)
        },
        {
            field: RowsField.bWeight,
            headerName: "Weight",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderHeader: () => (
                <>
                    {renderHeadFilter(RowsField.bWeight, "Weight")}
                </>
            ),
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.bWeight].toFixed(2)
                    }
                </div>)
        },
        // {
        //     field: RowsField.bPcs,
        //     headerName: "Pcs",
        //     minWidth: 100,
        //     flex: 1,
        //     headerAlign: "center",
        //     headerClassName: itemGridHeadClass,
        //     align: "center",
        //     renderCell: ({ row }) =>
        //     (
        //         <div>
        //             {row[RowsField.bPcs]
        //             }
        //         </div>)
        // },


        {
            field: RowsField.dRate,
            headerName: "Rate($)",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderHeader: () => (
                <>
                    {renderHeadFilter(RowsField.dRate, "Rate($)")}
                </>
            ),
            renderCell: ({ row }) =>
            (
                <div className="">
                    <input size="sm" variant="flat" color="success" type="text" name={RowsField.dRate}
                        className="bg-green-100 w-20 rounded-md text-green-600 h-7  border-1 border-green-200 p-1  text-xs"
                        onChange={(e) => handleChange(e, row.id)} value={row[RowsField.dRate]} />
                </div>)
        },
        {
            field: RowsField.convRate,
            headerName: "Conv Rate",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div className="">
                    <input size="sm" variant="flat" color="warning" type="text" name={RowsField.convRate}
                        className="bg-yellow-100 w-20 rounded-sm text-yellow-600 h-7  border-1 border-yellow-200 p-1  text-sm"
                        onChange={(e) => handleChange(e, row.id)} value={row[RowsField.convRate]} />
                </div>)
        },
        {
            field: RowsField.rate,
            headerName: "Rate",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderHeader: () => (
                <>
                    {renderHeadFilter(RowsField.rate, "Rate")}
                </>
            ),
            renderCell: ({ row }) =>
            (
                <div className="">
                    {/* <Input size="sm" variant="flat" color="danger"
                   
                     type="text" name={RowsField.rate}
                        onChange={(e) => handleChange(e, row.id)} value={row[RowsField.rate]} /> */}
                    <input size="sm" variant="flat" color="danger"
                        className="bg-yellow-100 w-20 rounded-md text-yellow-600 h-7  border-1 border-yellow-200 p-1  text-xs"
                        type="text" name={RowsField.rate}
                        onChange={(e) => handleChange(e, row.id)} value={row[RowsField.rate]} />

                </div>)
        },
        {
            field: RowsField.amount,
            headerName: "Amount",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderHeader: () => (
                <>
                    {renderHeadFilter(RowsField.amount, "Amount")}
                </>
            ),
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.amount]
                    }
                </div>
            )
        },
        {
            field: RowsField.dAmount,
            headerName: "Amount($)",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderHeader: () => (
                <>
                    {renderHeadFilter(RowsField.dAmount, "Amount($)")}
                </>
            ),
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.dAmount]
                    }
                </div>)
        },
        {
            field: RowsField.lab,
            headerName: "Lab",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderHeader: () => (
                <>
                    {renderHeadFilter(RowsField.lab, "Lab")}
                </>
            ),
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.lab]
                    }
                </div>)
        },

        {
            field: RowsField.lwRatio,
            headerName: "LxW Ratio",
            minWidth: 110,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderHeader: () => (
                <>
                    {renderHeadFilter(RowsField.lwRatio, "LW Ratio")}
                </>
            ),
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.lwRatio]
                    }
                </div>)
        },
    ]
    const getColName = (colName) => {
        if (columns && columns.length > 0) {
            const filData = columns.filter((ele) => ele.field == colName)
            if (filData && filData.length > 0) {
                return filData[0].headerName
            }
            else return colName
        }
        else return ""
    }
    const handleSubmit = () => {
        funUpdate({
            data: {
                comp_code: compCode.join(","),
                list_data: rows,
                login_userid: user.username,
                trade_of: selStockType,
            }
        })
    }
    const setCurrencyColumnVisiblity = (column) => {

        const RsCol = [RowsField.rate, RowsField.amount]
        const DCol = [RowsField.dRate, RowsField.dAmount, RowsField.convRate]
        if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS && RsCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar && DCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.DUAL)
            return true
        else
            return false
    }
    const handleResetFilter = () => {
        setSelColor(new Set([]));
        setSelShape(new Set([]))
        setSelFromSize("")
        setSelToSize("")
        setSelPurity(new Set([]))
        setSelFancyColor(new Set([]))
        setSelLab("")
        setSelDollaRate(null)
        setSelRsRate(null)
        filterData({
            data: {
                compcode: compCode.join(","),
                lotno: "", pktno: "",
                tradeof: selStockType,
                fweight: "",
                tweight: "",
                lab: "",
                scode: "", shcode: "", qcode: "", lotno: "", pktno: "", fancycolor: "",
                drate: null, rate: null
            }

        })
    }
    //console.log(row)
    const handleFilter = () => {

        //     const filters = {
        //         shape: [...selShape],
        //         color: [...selColor],
        //         purity: [...selPurity],
        //         fromSize:selFromSize,
        //         toSize:selToSize,
        //         lab:selLab
        //     };

        //     const filteredData = data.filter(item => {
        //         if (filters.shape.length && !filters.shape.includes(item[RowsField.shapeCode]))
        //             return false;
        //         if (filters.color.length && !filters.color.includes(item[RowsField.colorCode]))
        //             return false;
        //         if (filters.purity.length && !filters.purity.includes(item[RowsField.purityCode]))
        //             return false;
        //            if (filters.fromSize != null && filters.fromSize != "" && item[RowsField.bWeight] < filters.fromSize) return false;
        //            if (filters.toSize != null && filters.toSize != "" && item[RowsField.bWeight] > filters.toSize) return false;
        //            if (filters.lab && filters.lab !=""&& item[RowsField.lab].toLowerCase() !== filters.lab.toLowerCase())
        //             return false;

        //         return true;
        //     });
        //     setRows(filterData)
        //     console.log(filteredData)
        // }
        // else {
        const getValue = (obj) => { return Array.from(obj).join(",") }

        filterData({
            data: {
                compcode: compCode.join(","),
                lotno: "", pktno: "",
                tradeof: selStockType,
                fweight: selFromSize,
                tweight: selToSize,
                lab: selLab,
                scode: getValue(selShape), shcode: getValue(selColor), qcode: getValue(selPurity), fancycolor: getValue(selFancyColor), lotno: "", pktno: "",
                drate: selDollarRate,
                rate: selRsRate
            }

        })
        // }
    }
    const handleDelet = (key, name) => {
        if (name == 'shape') {
            const newFilter = selShape
            newFilter.delete(key)
            setSelShape(new Set(newFilter));
        }
        else if (name == 'color') {
            const newFilter = selColor
            newFilter.delete(key)
            setSelColor(new Set(newFilter));
        }
        else if (name == 'purity') {
            const newFilter = selPurity
            newFilter.delete(key)
            setSelPurity(new Set(newFilter));
        }
        else if (name == 'fancycolor') {
            const newFilter = selFancyColor
            newFilter.delete(key)
            setSelFancyColor(new Set(newFilter));
        }
    }
    if (isPendingData) {
        return <LoadingCard />
    }
    if (isErrorFetch, isError) {
        return <ErrorCard />
    }
    return (
        <MainContainer
            pageName={"Single Packet Price Update"}
            breadcrumbs={["Stock", "Single Packet Price Update"]}

        >
            <div className={` ${isMobile ? "flex-wrap" : "sm:flex-wrap"}   items-center  w-full items-center gap-4  bg-white shadow border-1 p-2   mb-2`}>
                <div className={`flex   ${isMobile ? "flex-wrap" : ""} gap-4   items-center `}>

                    {/* <Autocomplete
                        size="sm"
                        isRequired
                        name={formField.stockType}
                        color={"success"}
                        label={"Stock Type"}
                        eventResizeFeature={true}
                        selectionMode="single"
                        labelPlacement="outside"
                        showScrollIndicators={true}
                        placeholder={"select"}
                        className="max-w-24 font-semibold"
                        classNames={{
                            label: "text-xs text-black font-bold",
                        }}
                        isClearable={false}
                        variant="flat"
                        onSelectionChange={setSelStockType}
                        selectedKey={selStockType}
                    >

                        <AutocompleteItem key={"P"}  >Polish</AutocompleteItem>
                        <AutocompleteItem key={"R"}  >Rough</AutocompleteItem>

                    </Autocomplete> */}
                    <Input
                        type={"number"}
                        name={formField.fromSize}
                        placeholder={"From Size"}
                        label={"Form Size"}
                        labelPlacement="outside"
                        value={selFromSize}
                        variant={"bordered"}
                        onChange={(e) => setSelFromSize(e.target.value)}
                        size={"sm"}
                        className="max-w-24"
                        classNames={{
                            label: "text-xs text-black font-bold",
                        }}
                    ></Input>
                    <Input
                        type={"number"}
                        name={formField.toSize}
                        placeholder={"To Size"}
                        label={"To Size"}
                        labelPlacement="outside"
                        value={selToSize}
                        variant={"bordered"}
                        onChange={(e) => setSelToSize(e.target.value)}
                        size={"sm"}
                        className="max-w-24"
                        classNames={{
                            label: "text-xs text-black font-bold",
                        }}
                    ></Input>
                    <Select
                        size="sm"
                        name={formField.lab}
                        label={"Lab"}
                        color="default"
                        eventResizeFeature={true}
                        selectionMode="single"
                        labelPlacement="outside"
                        showScrollIndicators={true}
                        placeholder={"select"}
                        className="max-w-32 font-semibold "
                        classNames={{
                            label: "text-xs text-slate-700 font-bold",
                        }}
                        variant="bordered"
                        isVirtualized
                        items={
                            masterData && masterData?.labMaster ? masterData.labMaster : []
                        }
                        onChange={(e) => setSelLab(e.target.value)}
                        selectedKeys={[selLab]}
                    >
                        {(list) => (
                            <SelectItem
                                key={list.LabId}
                            >
                                {list.LabId}
                            </SelectItem>
                        )}
                    </Select>
                    <div className={`flex  ${isMobile ? "flex-wrap" : ""}  gap-4 w-full`}>

                        <Select
                            size="sm"
                            name={formField.shapeCode}
                            label={"Shape"}
                            color="default"
                            eventResizeFeature={true}
                            selectionMode="multiple"
                            labelPlacement="outside"
                            showScrollIndicators={true}
                            placeholder={"--select-"}
                            className="w-full"
                            classNames={{
                                label: "text-xs font-semibold",
                            }}

                            variant="bordered"
                            isVirtualized
                            items={
                                masterData && masterData?.shapeMaster ? masterData.shapeMaster : []
                            }
                            renderValue={(items) => {
                                return (
                                    <div className="flex gap-2 w-full" >
                                        {items.map((item) => (
                                            <div key={item.S_Code} className="flex  text-xs">
                                                <Chip
                                                    key={item.S_Code}
                                                    label={item.data.S_Name}
                                                    onDelete={() => handleDelet(item.key, 'shape')}
                                                    size="small"
                                                    color="secondary"
                                                    variant="outlined"
                                                    sx={{ height: 22, fontSize: "10px" }}
                                                />
                                                {/* <Chip size="sm" radius="sm" variant="flat" color="default" className="text-xs h-4" key={item.S_Code}><strong style={{ fontSize: "0.6rem" }} className=" text-blue-800" > {item.data.S_Name}</strong></Chip>
                                                <FontAwesomeIcon className="text-xs text-orange-700" onClick={() => handleDelet(item.key, 'shape')} icon={faCircleXmark} /></div> */}
                                            </div>
                                        ))}
                                    </div>
                                );
                            }}
                            onSelectionChange={setSelShape}
                            selectedKeys={selShape}
                        >
                            {(list) => (
                                <SelectItem
                                    key={list.S_Code}
                                >
                                    {list.S_Name}
                                </SelectItem>
                            )}
                        </Select>
                    </div>
                </div>

                <div className={`flex ${isMobile ? "flex-wrap " : ""} gap-4 mt-3  justify-center items-center`}>
                    <Select
                        size="sm"
                        name={formField.colorCode}
                        label={"Color"}
                        color="default"
                        eventResizeFeature={true}
                        selectionMode="multiple"
                        labelPlacement="outside"
                        showScrollIndicators={true}
                        placeholder={"--select--"}
                        className="w-full "
                        classNames={{
                            label: "text-xs font-semibold",
                        }}
                        isClearable={true}
                        variant="bordered"
                        isVirtualized
                        items={
                            masterData && masterData?.colorMaster ? masterData.colorMaster : []
                        }
                        renderValue={(items) => {
                            return (
                                <div className="flex gap-2 w-full" >
                                    {items.map((item) => (
                                        <div key={item.Sh_Code} className="flex  text-xs">
                                            <Chip
                                                key={item.Sh_Code}
                                                label={item.data.Sh_Name}
                                                onDelete={() => handleDelet(item.key, 'color')}
                                                size="small"
                                                color="secondary"
                                                variant="outlined"
                                                sx={{ height: 22, fontSize: "10px" }}
                                            />
                                        </div>
                                        // <Chip size="sm" radius="sm" variant="flat" color="default" className="text-xs h-4" key={item.Sh_Code}><strong style={{ fontSize: "0.6rem" }} className="text-blue-800"  > {item.data.Sh_Name}</strong></Chip>
                                        // <FontAwesomeIcon className="text-xs text-orange-700" onClick={() => handleDelet(item.key, 'color')} icon={faCircleXmark} /></div>
                                    ))}
                                </div>
                            );
                        }}
                        onSelectionChange={setSelColor}
                        selectedKeys={selColor}
                    >
                        {(list) => (
                            <SelectItem
                                key={list.Sh_Code}
                            >
                                {list.Sh_Name}
                            </SelectItem>
                        )}
                    </Select>
                    <Select
                        size="sm"
                        name={formField.fancyColor}
                        label={"Fancy Color"}
                        color="default"
                        eventResizeFeature={true}
                        selectionMode="multiple"
                        labelPlacement="outside"
                        showScrollIndicators={true}
                        placeholder={"--select--"}
                        className="w-full"
                        classNames={{
                            label: "text-xs font-semibold",
                        }}
                        variant="bordered"
                        isVirtualized
                        items={
                            masterData && masterData?.fancyColorMaster ? masterData.fancyColorMaster : []
                        }
                        onSelectionChange={setSelFancyColor}
                        selectedKeys={selFancyColor}
                        renderValue={(items) => {
                            return (
                                <div className="flex gap-2 w-full" >
                                    {items.map((item) => (
                                        <div key={item.Fancy_Col} className="flex  text-xs">
                                            <Chip
                                                key={item.Fancy_Col}
                                                label={item.data.Fancy_Col}
                                                onDelete={() => handleDelet(item.key, 'fancycolor')}
                                                size="small"
                                                color="secondary"
                                                variant="outlined"
                                                sx={{ height: 22, fontSize: "10px" }}
                                            />
                                            {/* <Chip size="sm" radius="sm" variant="flat" color="default" className="text-xs h-4" key={item.Q_Code}><strong style={{ fontSize: "0.6rem" }} className=" text-blue-800" > {item.data.Q_Name}</strong></Chip>
                                            <FontAwesomeIcon className="text-xs text-orange-700" onClick={() => handleDelet(item.key, 'purity')} icon={faCircleXmark} /></div> */}
                                        </div>

                                    ))}
                                </div>
                            );
                        }}
                    >
                        {(list) => (
                            <SelectItem
                                key={list.Fancy_Col}
                            >
                                {list.Fancy_Col}
                            </SelectItem>
                        )}
                    </Select>
                    <Select
                        size="sm"
                        name={formField.purityCode}
                        label={"Purity"}
                        color="default"
                        eventResizeFeature={true}
                        selectionMode="multiple"
                        labelPlacement="outside"
                        showScrollIndicators={true}
                        placeholder={"--select--"}
                        className="w-full"
                        classNames={{
                            label: "text-xs font-semibold",
                        }}
                        variant="bordered"
                        isVirtualized
                        items={
                            masterData && masterData?.purityMaster ? masterData.purityMaster : []
                        }
                        onSelectionChange={setSelPurity}
                        selectedKeys={selPurity}
                        renderValue={(items) => {
                            return (
                                <div className="flex gap-2 w-full" >
                                    {items.map((item) => (
                                        <div key={item.Q_Code} className="flex  text-xs">
                                            <Chip
                                                key={item.Q_Code}
                                                label={item.data.Q_Name}
                                                onDelete={() => handleDelet(item.key, 'purity')}
                                                size="small"
                                                color="secondary"
                                                variant="outlined"
                                                sx={{ height: 22, fontSize: "10px" }}
                                            />
                                            {/* <Chip size="sm" radius="sm" variant="flat" color="default" className="text-xs h-4" key={item.Q_Code}><strong style={{ fontSize: "0.6rem" }} className=" text-blue-800" > {item.data.Q_Name}</strong></Chip>
                                            <FontAwesomeIcon className="text-xs text-orange-700" onClick={() => handleDelet(item.key, 'purity')} icon={faCircleXmark} /></div> */}
                                        </div>

                                    ))}
                                </div>
                            );
                        }}
                    >
                        {(list) => (
                            <SelectItem
                                key={list.Q_Code}
                            >
                                {list.Q_Name}
                            </SelectItem>
                        )}
                    </Select>

                    <Input
                        type={"number"}
                        name={formField.dRate}
                        placeholder={"Rate ($)"}
                        label={"Rate ($)"}
                        labelPlacement="outside"
                        value={selDollarRate}
                        variant={"bordered"}
                        onChange={(e) => setSelDollaRate(e.target.value)}
                        size={"sm"}
                        className="max-w-24"
                        classNames={{
                            label: "text-xs text-black font-bold",
                        }}
                    ></Input>
                    <Input
                        type={"number"}
                        name={formField.dRate}
                        placeholder={"Rate (₹)"}
                        label={"Rate (₹)"}
                        labelPlacement="outside"
                        value={setSelRsRate}
                        variant={"bordered"}
                        onChange={(e) => setSelRsRate(e.target.value)}
                        size={"sm"}
                        className="max-w-24"
                        classNames={{
                            label: "text-xs text-black font-bold",
                        }}
                    ></Input>
                    {/* <div className={`   items-center `}>
                    <RadioGroup label=" " size="sm" color="success"
                        value={selIsCertiNo} onValueChange={setSelIsCertiNo}
                        className="text-xs" orientation={`${isMobile ? "horizontal" : "horizontal"}`}>
                        <Radio value="null">All</Radio>
                        <Radio value="1">Certi</Radio>
                        <Radio value="0">NonCerti</Radio>
                    </RadioGroup>


                </div> */}

                </div>
                <div className={`flex gap-4  ${isMobile ? 'w-full' : ''} mt-2  justify-center items-center `}>
                    {/* </div>
                        <div className={`flex  items-center gap-2 `}> */}
                    <Button
                        size="sm"
                        color="primary"
                        className="bg-blue-700 max-w-28"
                        startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                        onPress={handleFilter}

                    // isLoading={isPending}
                    >
                        Find Stock
                    </Button>
                    <Button
                        style={{ marginLeft: "5px" }}
                        color="primary"
                        size="sm"
                        className="max-w-22 bg-slate-700"
                        startContent={<FontAwesomeIcon icon={faFilter} />}
                        onPress={handleResetFilter}
                    >
                        Reset
                    </Button>
                </div>

            </div>
            <div>
                <div className="mb-5" style={{ display: "flex", flexDirection: "row", gap: 4 }}>
                    {Object.entries(selectFilter).map(([field, values]) => (
                        <div key={field} style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                            <strong style={{ fontSize: "0.6rem" }} className="text-xs uppercase"> {values.length > 0 ? getColName(field) + " :" : ""} </strong>
                            {values.map(value => (
                                <Chip
                                    key={`${field}-${value}`}
                                    label={value}
                                    onDelete={() => handleRemoveTag(field, value)}
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                    sx={{ height: 22, fontSize: "11px" }}
                                />
                            ))}
                        </div>
                    ))}
                </div>
                <Box sx={{ height: rows.length > 10 ? 400 : "auto", width: '100%' }}>
                    {CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS && data && data.length > 0 ?
                        <div className={`flex justify-end ${isMobile ? "flex-wrap" : ""} `}>
                            <div className={` bg-rose-50 p-2  flex gap-2`}>
                                <Input name={RowsField.convRate} placeholder="" labelPlacement="outside-left"
                                    color="danger" label="Conv Rate :" variant="underlined"
                                    size="sm"
                                    className="w-26 h-8 font-bold bg-white text-rose-700"
                                    type="text"
                                    onChange={(e) => setSelConRate(e.target.value)}
                                    //onChange={(e) => handleChange(e, RowsField.convRate)}
                                    value={selConRate}></Input>

                                <Input name={"fixRate"} placeholder="" labelPlacement="outside-left"
                                    color="primary" label="Rate (₹):" variant="underlined"
                                    size="sm"
                                    className="w-26 h-8 font-bold bg-white text-orange-500"
                                    type="text"
                                    onChange={(e) => setfixRate(e.target.value)}
                                    // onChange={(e) => handleChange(e, "fixRate")}
                                    value={fixRate}></Input>
                            </div>
                            <div className="flex gap-2 bg-rose-50 p-2 justify-start">
                                <Input name={"fixRateDollar"} placeholder="" labelPlacement="outside-left"
                                    color="success" label="Rate ($):" variant="underlined"
                                    size="sm"
                                    className={` h-8 font-bold bg-white text-green-700 ${isMobile ? "w-2/5" : "w-26"}`}
                                    type="text"
                                    onChange={(e) => setfixRateDollar(e.target.value)}
                                    //onChange={(e) => handleChange(e, "fixRateDollar")}
                                    value={fixRateDollar}></Input>

                                <Button
                                    color="primary"
                                    // type="submit"
                                    size="sm"
                                    onPress={handleSetValue}
                                    variant="shadow"
                                    className="h-6"
                                >Set Rate</Button>
                                <Button color="default"
                                    // type="submit"
                                    size="sm"
                                    className="h-6 bg-slate-600 text-white"
                                    onPress={handleRestSetValue}
                                    variant="shadow">Reset</Button>

                            </div>
                        </div> : ""}
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        editMode="row"
                        columnHeaderHeight={65}
                        rowHeight={35}
                        disableColumnSorting={true}
                        disableColumnMenu={true}
                        columnVisibilityModel={{
                            [RowsField.rate]: setCurrencyColumnVisiblity(RowsField.rate),
                            [RowsField.dRate]: setCurrencyColumnVisiblity(RowsField.dRate),
                            [RowsField.amount]: setCurrencyColumnVisiblity(RowsField.amount),
                            [RowsField.dAmount]: setCurrencyColumnVisiblity(RowsField.dAmount),
                            [RowsField.convRate]: false
                        }}
                        getRowClassName={(params) => {

                            if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS)
                                return params.row.S_Rate <= 0 ? "price-zero-row" : "row-class"
                            else
                                return params.row.Rate <= 0 ? "price-zero-row" : "row-class"

                        }}

                        sx={{
                            "& .price-zero-row": {
                                backgroundColor: "#ffdede", // red-100
                                color: "#ea0606ff",
                                fontSize: "11px",

                                "&:hover": {
                                    backgroundColor: "#ffffff"
                                }
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                position: 'sticky',
                                top: 0,
                                zIndex: 1, // Make sure the headers are above the rows when scrolling

                            },
                            '& .select-row': {
                                backgroundColor: "#ebe8e8"
                            },
                            '& .row-class': {
                                fontSize: "11px",
                                backgroundColor: "#FFFFFF"
                            },
                            '& .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon': {
                                display: 'none',
                            },
                            '& .MuiDataGrid-columnHeader .MuiDataGrid-iconSeparator': {
                                display: 'none',
                            },
                            '& .MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer': {
                                display: 'none',
                            },
                            '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
                                paddingLeft: 0,
                                paddingRight: 0,
                                marginLeft: 0,
                                marginRight: 0,
                            },

                        }}


                    />

                </Box>
                <div>
                    {rows && rows.length > 0 ?
                        <div className="justify-center flex items-center gap-4 mt-2">
                            {/* <div className="justify-center flex gap-5 mt-5"> */}
                            <Button
                                color="primary"
                                // type="submit"
                                size="sm"
                                onPress={handleSubmit}
                                variant="shadow"
                                isLoading={isPending}
                                startContent={<FontAwesomeIcon icon={faSave} />}
                            >
                                Update Price
                            </Button>

                            <Button
                                color="danger"
                                variant="shadow"
                                size="sm"
                                tabIndex={-1}
                                onPress={handleFilter}
                                startContent={<FontAwesomeIcon icon={faCancel} />}
                            >
                                Cancel
                            </Button>
                        </div> : ""}
                </div>
            </div>

        </MainContainer>
    )
}
export default SinglePktPriceUpdate